import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import { HeaderProvider } from './context/HeaderContext';
import { ChatProvider } from './context/ChatContext';
import Layout from './containers/Layout';
import Main from './containers/Main';
import Chat from './pages/Chat';
import Login from './pages/Login';
import CreateAccount from './pages/CreateAccount';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/404';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ChatProvider>
          <SidebarProvider>
            <HeaderProvider>
              <Router>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/create-account" element={<CreateAccount />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/app/*" element={<Layout />} />
                  <Route path="/" element={<Main />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Router>
            </HeaderProvider>
          </SidebarProvider>
        </ChatProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
